export const PAYMENTS_CARD_BEGIN = 'PAYMENTS_CARD_BEGIN';
export const PAYMENTS_CARD_SUCCESS = 'PAYMENTS_CARD_SUCCESS';
export const PAYMENTS_CARD_FAILURE = 'PAYMENTS_CARD_FAILURE';

const fetchPaymentsCardSuccess = (data) => ({
  type: PAYMENTS_CARD_SUCCESS,
  payload: data,
});

const fetchPaymentsCardBegin = () => ({
  type: PAYMENTS_CARD_BEGIN,
});

const fetchPaymentsCardFailure = (error) => ({
  type: PAYMENTS_CARD_FAILURE,
  error
});

export const fetchPaymentsCard = (cardNumber, page, pageSize) => (dispatch) => {
  dispatch(fetchPaymentsCardBegin());

  return fetch(`/api/cards/${cardNumber}/payments?page=${page++}&pageSize=${pageSize}`, {
      method: 'GET',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' }})
    .then(response => handleErrors(response))
    .then(data => dispatch(fetchPaymentsCardSuccess(data)))
    .catch(err => dispatch(fetchPaymentsCardFailure(err.message)));
}

function handleErrors(response) {
  if (!response.ok) {
    return response.json().then(errorResponse => {
      let msg;
      if (errorResponse.extraParameters && Array.isArray(errorResponse.extraParameters.json)) {
        msg = errorResponse.extraParameters.json[0];
      }
      if (response.status === 404) {
        throw new Error(msg || errorResponse.detail || 'Deze pas werd niet gevonden.');
      } else if (response.status === 403) {
        throw new Error(msg || 'U heeft geen toegang.');
      } else {
        throw new Error(msg || 'Er is een fout opgetreden.');
      }
    }).catch(err => {
      throw err;
    });
  }
  return response.json();
}